import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

const SocketContext = createContext();

export const useSocket = () => {
    return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        // Connect to backend URL with automatic reconnection
        const newSocket = io(import.meta.env.VITE_API_URL || 'http://localhost:5001', {
            reconnection: true,
            reconnectionAttempts: 10,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            timeout: 25000,
            transports: ['websocket', 'polling'],
            withCredentials: true,
            autoConnect: true,
            // Reduce lag: smaller buffers and faster ping
            upgrade: true,
            rememberUpgrade: true,
        });

        // Connection event handlers
        newSocket.on('connect', () => {
            console.log('[Socket] Connected to server');
        });

        newSocket.on('disconnect', (reason) => {
            console.log('[Socket] Disconnected from server:', reason);
        });

        newSocket.on('reconnect', (attemptNumber) => {
            console.log('[Socket] Reconnected to server after', attemptNumber, 'attempts');
        });

        newSocket.on('reconnect_error', (error) => {
            console.error('[Socket] Reconnection error:', error);
        });

        newSocket.on('reconnect_failed', () => {
            console.error('[Socket] Failed to reconnect to server');
        });

        newSocket.on('connect_error', (error) => {
            console.error('[Socket] Connection error:', error);
        });

        setSocket(newSocket);

        return () => {
            console.log('[Socket] Closing socket connection');
            newSocket.close();
        };
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};
